import {accountPaths, downloadsPaths} from '~/utils/services/paths';
import type {IArticleBox, IPaginatedResponse, IDownloadsPagination, IDownloadPayload} from '~/types';

export const getNonReviewedProducts = async (email: string, page = 1) => {
    return await $cpFetch<IPaginatedResponse<IArticleBox>>(accountPaths.noReviews(email), {
        params: {
            'page[number]': page,
        },
    });
};

export const getDownloads = async (userId: string, options: IDownloadsPagination) => {
    return await $cpFetch<IDownloadPayload>(downloadsPaths.all(userId), {
        params: {
            'page[number]': options.pageNumber,
            'page[size]': options.pageSize,
        },
    });
};
